module.exports = __webpack_public_path__ + "static/media/cloud_watch3.ba28691f.png";